export enum IntegrationType {
  GOOGLE_CLASSROOM = 'Google Classroom',
  MICROSOFT_TEAMS = 'Microsoft Teams',
  GOOGLE_SITES_SOURCE = 'Google Sites Source',
  GOOGLE_SITES_DESTINATION = 'Google Sites Destination',
}
